var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroundrule(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 15.75H13.625C14.6605 15.75 15.5 14.9105 15.5 13.875V6.27875C15.5 5.68202 15.2629 5.10972 14.841 4.68776L13.0622 2.90901C12.6403 2.48705 12.068 2.25 11.4712 2.25H6.125C5.08947 2.25 4.25 3.08947 4.25 4.125V14.25C4.25 15.0784 4.92157 15.75 5.75 15.75Z",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4823 5.99986H12.875C12.2537 5.99986 11.75 5.49618 11.75 4.87486V2.26758",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 9H9.6875",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12H9.6875",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 8.90625C7.19822 8.90625 7.15625 8.94822 7.15625 9C7.15625 9.05178 7.19822 9.09375 7.25 9.09375C7.30178 9.09375 7.34375 9.05178 7.34375 9C7.34375 8.94822 7.30178 8.90625 7.25 8.90625",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 11.9062C7.19822 11.9062 7.15625 11.9482 7.15625 12C7.15625 12.0518 7.19822 12.0938 7.25 12.0938C7.30178 12.0938 7.34375 12.0518 7.34375 12C7.34375 11.9482 7.30178 11.9062 7.25 11.9062",
    stroke: "#202020",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundrule);
export default __webpack_public_path__ + "static/media/groundrule.08eaca4adcf06939ee3e2670c712341e.svg";
export { ForwardRef as ReactComponent };